import React, { useState, useEffect } from "react";

import AdobeCertified from "../assets/images/adobe-cert.png";
import QuantumCertified from "../assets/images/qm-cert.png";
import GoogleCertified from "../assets/images/ga-analytics.png";

const Portfolio = () => {

  useEffect(() => {
    // Function to initialize fancybox for the gallery

    // Event listener to toggle 'full' class on image click
    const handleImageClick = (event) => {
      event.target.classList.toggle("full");
    };

    // Attach click event to gallery images
    const galleryLinks = document.querySelectorAll(".gallery-link img");
    galleryLinks.forEach((link) => {
      link.addEventListener("click", handleImageClick);
    });

    // Cleanup function to remove event listeners when component unmounts
    return () => {
      galleryLinks.forEach((link) => {
        link.removeEventListener("click", handleImageClick);
      });
    };
  }, []);
  return (
    <>
      {/* <!-- ====================================== Section certification ===================================== --> */}
      <section className="portfolio-section" id="certification">
        <div className="heading-container">
          <h2 className="section-heading-text coding-skill-text fade_up">
            Certifications
          </h2>
          <div className="line"></div>
        </div>
        <div className="portfolios-group-main">
          <a target="_blank" href="https://certification.adobe.com/credential/verify/e4bdbd31-f530-11ef-9883-42010a40002a" style={{textDecoration: "none", color: "transparent"}}>
            <div>
              <div
                className="image-container popup-btn"
              >
                <img src={AdobeCertified} alt="content-img" />
              </div>
              <p className="Corporate">Adobe Certified Proffesional</p>
              <p className="Corporate-sub">ADOBE</p>
            </div>
          </a>
          <a target="_blank" href="https://learn.quantummetric.com/certificate/cR3QdR86xQ" style={{textDecoration: "none", color: "transparent"}}>
            <div>
              <div>
                <div
                  className="image-container"
                  id="vimeo"
                >
                  <img src={QuantumCertified} alt="vimeo-video-img" />
                </div>
              </div>
              <p className="Corporate">Quantum Metric certified</p>
              <p className="Corporate-sub">Quantum Metric University</p>

            </div>
          </a>
          <a target="_blank" href="https://skillshop.credential.net/7ceddd33-20ec-4731-b625-3f8bd79d1dea#acc.351CI7y0" style={{textDecoration: "none", color: "transparent"}}>
            <div>
              <div>
                <div
                  className="image-container"
                  id="vimeo"
                >
                  <img src={GoogleCertified} alt="vimeo-video-img" />
                </div>
              </div>
              <p className="Corporate">Google Analytics certified</p>
              <p className="Corporate-sub">GOOGLE</p>

            </div>
          </a>
        </div>
      </section>
    </>
  );
};
export default Portfolio;
